var _g, _g2, _path, _g3, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 132,
    viewBox: "0 0 232 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1930_13993)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 163.5,
    cy: 63.5,
    r: 53.5,
    fill: "#AEDFFF",
    fillOpacity: 0.15,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1930_13993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.478 60.7828C149.436 60.7828 146.198 57.5201 146.198 53.4784C146.198 49.4366 149.436 46.174 153.478 46.174C157.52 46.174 160.782 49.4366 160.782 53.4784C160.782 57.5201 157.52 60.7828 153.478 60.7828ZM172.956 60.7828C168.915 60.7828 165.676 57.5201 165.676 53.4784C165.676 49.4366 168.915 46.174 172.956 46.174C176.998 46.174 180.261 49.4366 180.261 53.4784C180.261 57.5201 176.998 60.7828 172.956 60.7828ZM172.956 65.6523C178.63 65.6523 190 68.5011 190 74.1741V80.2611H155.913V74.1741C155.913 68.5011 167.283 65.6523 172.956 65.6523ZM153.478 65.6523C154.184 65.6523 154.988 65.701 155.84 65.7741C153.015 67.8193 151.043 70.5706 151.043 74.1741V80.2611H136.435V74.1741C136.435 68.5011 147.805 65.6523 153.478 65.6523Z",
    fill: "#AEDFFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2941 68.8235C30.0553 68.8235 34.6712 64.1729 34.6712 58.4118C34.6712 52.6506 30.0553 48 24.2941 48C18.5329 48 13.8824 52.6506 13.8824 58.4118C13.8824 64.1729 18.5329 68.8235 24.2941 68.8235ZM24.2941 75.7647C16.2076 75.7647 0 79.8253 0 87.9118V96.5882H48.5882V87.9118C48.5882 79.8253 32.3806 75.7647 24.2941 75.7647Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1930_13993)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 92.5,
    r: 15.5,
    fill: "#3A4653"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1930_13993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.0597 93.4371H46.4372V99.0596H44.563V93.4371H38.9404V91.5629H44.563V85.9403H46.4372V91.5629H52.0597V93.4371Z",
    fill: "#AEDFFF"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.6105 30.0029L107.111 21.503L108.738 20.3004L107.411 18.7737L97.4107 7.27368L94.5902 9.72627L100.858 16.9339C86.5942 13.9958 75.0179 16.5632 66.6161 22.1132C57.5779 28.0835 52.3527 37.4221 51.4571 46.6465L51.2765 48.5066L54.9967 48.8678L55.1773 47.0077C55.964 38.905 60.5799 30.5801 68.6762 25.2319C76.4164 20.1189 87.4675 17.6489 101.607 20.9235L93.389 26.9971L95.6105 30.0029Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1930_13993",
    x: 103,
    y: 3,
    width: 129,
    height: 129,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1930_13993"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1930_13993",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1930_13993",
    x: 23,
    y: 70,
    width: 53,
    height: 53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1930_13993"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1930_13993",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1930_13993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.0003,
    height: 56.0003,
    fill: "white",
    transform: "matrix(-1 0 0 1 190 34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1930_13993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.4902,
    height: 22.4902,
    fill: "white",
    transform: "translate(34.2549 81.2549)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.ef50955d96b89bb54169b9c1f18121a3.svg";
export { ForwardRef as ReactComponent };